import React from 'react';
import Home from './components/Home';
import './App.css';

class App extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loggedIn: false
        };
    }

    componentDidMount() {
        this.validateSession();
    }

    render() {
        return(
            <div className="app-container">
                { this.state.loggedIn === false ? 
                    <Home />
                :
                    "none"
                }
            </div>
        );
    }

    validateSession() {
        let accessToken = localStorage.getItem("idtoken");
        if(accessToken == null){

        } else {
            if(!this.isTokenExpired(accessToken)){
                this.setState({ loggedIn: true });
            } else {

            }
        }
    }

    isTokenExpired(accessToken){
        try{
            let body = accessToken.split(".")[1];
            let json = JSON.parse(atob(body));
            if((json.exp * 1000) > Date.parse(new Date())){
                return false;
            }
            return true;
        }catch(e){
            return true;
        }
    }

}

export default App;
